import React, { useState, useEffect, useRef } from "react";
import "./css/styles.css";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import { SketchPicker } from "react-color";
import { Card, Button, TextField, FormControl, Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import ProgressBar from "./ProgressBar";

import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  getDoc,
} from "firebase/firestore";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import axios from "axios";
import cheerio from "cheerio";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUploader from "react-firebase-file-uploader";
import { db, storage, app } from "../firebase";
import { muiBbtn } from "./style";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";


export default function AddNewService() {
  const [categories, setCategories] = useState([]);
  const [Category, setCategory] = useState("");
  const [Title, setTitle] = useState("");
  const [Price, setPrice] = useState(""); ///To check if data if loaded or not from collection.
  const [Description, setDescription] = useState("");
  const [Variant, setVariant] = useState([]);
  const [UploadImage, setUploadImage] = useState("");
  const [UploadProgress, setUploadProgress] = useState(0);
  const [isProcessing, setisProcessing] = useState(false);
  const [newVariant, setnewVariant] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [filenames, setfilenames] = useState([]);
  const [downloadURLs, setdownloadURLs] = useState([]);
  const [isUploading, setisUploading] = useState(false);
  const [files, setFiles] = useState([]);
  const [SelectedColor, setSelectedColor] = useState("");
  const [Colors, setColors] = useState([]);
  const [selectedVariant, setselectedVariant] = useState("");
  const [VariantTypes, setVariantTypes] = useState([]);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [Stock, setStock] = useState("In Stock");
  const [countries, setCountries] = useState([]);
  const [newCountry, setnewCountry] = useState("");
  const [types, setTypes] = useState("");
  const fileUploader = useRef();
  console.log(newCountry, "newCountry");
  console.log(countries, "countries");
  const { DocId } = useParams();
  useEffect(() => {
    const getData = async () => {
      const data = await getDocs(
        query(collection(db, "category"), orderBy("name", "asc"))
      );
      //////Mapping Through App Documents And Then Saving them in Categories use
      data.docs.map((document) => {
        setCategories((row) => [
          ...row,
          {
            ...document.data(),
          },
        ]);
      });
      const countryData = await getDocs(
        query(collection(db, "countries"), orderBy("name", "asc"))
      );
      //////Mapping Through App Documents And Then Saving them in Categories use
      // Mapping through the documents and extracting only the country names
      const countryNames = countryData.docs.map(
        (document) => document.data().name
      );

      // Save the country names in state (if necessary)
      setCountries(countryNames);
      const variData = await getDocs(
        query(collection(db, "variant"), orderBy("name", "asc"))
      );
      //////Mapping Through App Documents And Then Saving them in Categories use
      variData.docs.map((document) => {
        setVariantTypes((row) => [
          ...row,
          {
            ...document.data(),
          },
        ]);
      });

      if (DocId) {
        getDoc(doc(db, "services", DocId)).then((res) => {
          setTitle(res.data().title);
          setPrice(res.data().price);
          setDescription(res.data().description);
          setCategory(res.data().category);
          setVariant(res.data().variants);
          setdownloadURLs(res.data().images);
          setThumbnail(res.data().thumbnail);
          setColors(res.data().colors);
          setStock(res.data().stock);
          setnewCountry(res.data().country);
          setWebsiteUrl(res.data().websiteUrl || "");
        });
      }
    };
    getData();
  }, []);
  const handleDelete = (variantType, elementToRemove) => {
    const updatedArray = Variant.map((obj, index) => {
      if (obj.variantType === variantType) {
        obj.values.splice(obj.values.indexOf(elementToRemove), 1);
        if (obj.values.length === 0) {
          return false;
        }
      }
      return obj;
    });
    const finalArray = updatedArray.filter(Boolean);
    setVariant(finalArray);
  };
  const handleDeleteColor = (c) => {
    setColors(Colors.filter((Colors) => Colors !== c));
  };

  const saveService = (url = null) => {
    var data = {
      title: Title,
      category: Category,
      description: Description,
      price: Price,
      variants: Variant,
      thumbnail: thumbnail,
      images: downloadURLs,
      colors: Colors,
      stock: Stock,
      country: newCountry,
      websiteUrl: websiteUrl,
      type: types,
    };
    if (url != null) {
      data.thumbnail = url;
    }

    if (DocId) {
      updateDoc(doc(db, "services", DocId), data)
        .then(() => {
          setisProcessing(false);
          toast.success("Service Updated");
          // formReset();
          setUploadProgress(0);
          setFiles([]);
          document.getElementById("uploadThumbnail").value = "";
          document.getElementById("uploadImages").value = "";
        })
        .catch((error) => {
          setisProcessing(false);

          toast.error("Error! unable to Update Service");
          console.log(error);
        });
    } else {
      const newDoc = doc(collection(db, "services"));
      data.id = newDoc.id;
      data.created_on = new Date();
      setDoc(newDoc, data)
        .then(() => {
          setisProcessing(false);

          toast.success("Service Added");
          formReset();
        })
        .catch((error) => {
          setisProcessing(false);
          toast.error("Error! unable to Add Service");
          console.log(error);
        });
    }
  };

  const handleUploadStart = () => {
    setisUploading(true);
    setUploadProgress(0);
  };

  const handleProgress = (progress) => {
    setUploadProgress(progress);
  };

  const handleUploadError = (error) => {
    setisUploading(false);
    console.error(error);
  };

  const handleUploadSuccess = async (filename) => {
    const downloadURL = await app
      .storage()
      .ref("Service_images")
      .child(filename)
      .getDownloadURL();

    setfilenames((old) => [...old, filename]);
    setdownloadURLs((old) => [...old, downloadURL]);
    setUploadProgress(0);
    setisUploading(false);
  };
  const handleUploadSuccessThumbnail = async (filename) => {
    const downloadURL = await app
      .storage()
      .ref("Service_images")
      .child(filename)
      .getDownloadURL();

    setThumbnail((old) => [...old, downloadURL]);
    setUploadProgress(0);
    setisUploading(false);
  };
  // const customOnChangeHandler = (event) => {
  //   // const {
  //   //   target: { files },
  //   // } = event;
  //   // setfiles((files)=>[...files,event.target.files])
  //   // const filesToStore = [];
  //   console.log("hyy");
  //   console.log(event);
  //   // event.target.files.forEach((file) => filesToStore.push(file));
  //   const filesToStore = Array.from(event.target.files);
  //   setFiles(filesToStore);
  // };

  // const startUploadManually = () => {
  //   files.forEach((file) => {
  //     fileUploader.current.startUpload(file);
  //   });
  // };

  const addService = () => {
    if (!Title || !Description || !Price || !Category) {
      toast.error("Kindly Fill All Input Fields");
      return;
    }

    setisProcessing(true);
    // startUploadManually();
    if (UploadImage) {
      const storageRef = ref(
        storage,
        `/Service_images/${Title + Math.floor(Math.random() * 1000) + 1}`
      );

      const uploadTask = uploadBytesResumable(storageRef, UploadImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setUploadProgress(percent);
        },
        (err) => console.log(err),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setUploadImage(null);
            saveService(url);
          });
        }
      );
    } else {
      saveService();
    }
  };
  const formReset = () => {
    setTitle("");
    setDescription("");
    setCategory("");
    setPrice("");
    setVariant([]);
    setdownloadURLs([]);
    setWebsiteUrl("");
    setUploadProgress(0);
    setFiles([]);
    document.getElementById("uploadThumbnail").value = "";
    document.getElementById("uploadImages").value = "";
  };

  const AddNewVariant = () => {
    {
      if (!selectedVariant || !newVariant) {
        toast.error("Variant can't Be Empty");
        return;
      }
      const index = Variant.findIndex(
        (x) => x?.variantType === selectedVariant
      );
      if (index === -1) {
        setVariant((variant) => [
          ...variant,
          { variantType: selectedVariant, values: [newVariant] },
        ]);
      } else {
        let newArray = [...Variant];
        newArray[index].values.push(newVariant);
        setVariant(newArray);
      }

      setnewVariant("");
      console.log(Variant);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        backgroundColor: "#212C62",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 60, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>{DocId ? "Update Service" : "ADD NEW Service"}</b>
            </h1>
          </div>
        </div>
        <div className="mt-2">
          <Box component="form" noValidate autoComplete="off">
            <TextField
              className="mb-4"
              sx={{ backgroundColor: "#FAFAFA" }}
              id="Service_title"
              label="Enter Service Title"
              value={Title}
              onChange={(e) => setTitle(e.target.value)}
              fullWidth
              variant="outlined"
            />
            <TextField
              className="mb-4"
              sx={{ backgroundColor: "#FAFAFA" }}
              label="Enter Service Price"
              fullWidth
              id="Service_price"
              value={Price}
              onChange={(e) => setPrice(e.target.value)}
              variant="outlined"
            />
            <TextField
              className="mb-4"
              sx={{ backgroundColor: "#FAFAFA" }}
              label="Enter Website URL"
              fullWidth
              id="Service_websiteUrl"
              value={websiteUrl}
              onChange={(e) => setWebsiteUrl(e.target.value)}
              variant="outlined"
            />
            <FormControl fullWidth className="mb-4" size="small">
              <InputLabel id="demo-simple-select-label">
                Select Category
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={Category}
                id="Service_category"
                label="Status"
                onChange={(e) => setCategory(e.target.value)}
              >
                {categories?.map((cat) => {
                  return <MenuItem value={cat.id}>{cat.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth className="mb-4" size="small">
              <InputLabel id="demo-simple-select-label">
                Select Country
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={newCountry}
                id="Service_country"
                label="Status"
                onChange={(e) => setnewCountry(e.target.value)}
              >
                {countries?.map((cat) => {
                  return <MenuItem value={cat}>{cat}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth className="mb-4" size="small">
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={types}
                id="Service_Variant"
                label="Status"
                style={{ padding: "8px" }}
                onChange={(e) => setTypes(e.target.value)}
              >
                <MenuItem value="Doctor">Doctor</MenuItem>;
                <MenuItem value="Dentist">Dentist</MenuItem>;
                <MenuItem value="Beauty">Beauty</MenuItem>;
                <MenuItem value="Housing-Rent/buy">Housing-Rent/buy</MenuItem>;
                <MenuItem value="Housing-Cleaning">Housing-Cleaning</MenuItem>;
                <MenuItem value="Housing-Handyman">Housing-Handyman</MenuItem>;
                <MenuItem value="Transport">Transport</MenuItem>;
                <MenuItem value="Food">Food</MenuItem>;
                <MenuItem value="Car Repair">Car Repair</MenuItem>;
                <MenuItem value="School Tutors">School Tutors</MenuItem>;
                <MenuItem value="Language">Language</MenuItem>;
                <MenuItem value="Lessons">Lessons</MenuItem>;
                <MenuItem value="Sport">Sport</MenuItem>;
                <MenuItem value="Leasure">Leasure</MenuItem>;
                <MenuItem value="Tourism">Tourism</MenuItem>;
                <MenuItem value="Financial">Financial</MenuItem>;
                <MenuItem value="Legal">Legal</MenuItem>;
                <MenuItem value="Other">Other</MenuItem>;
              </Select>
            </FormControl>
            <FormControl fullWidth className="mb-4" size="small">
              <InputLabel id="demo-simple-select-label">
                Stock Status
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={Stock}
                id="Service_Variant"
                label="Status"
                style={{ padding: "8px" }}
                onChange={(e) => setStock(e.target.value)}
              >
                <MenuItem value="In Stock">In Stock</MenuItem>;
                <MenuItem value="Out of Stock">Out of Stock</MenuItem>;
              </Select>
            </FormControl>
            <textarea
              className="mb-4"
              sx={{ backgroundColor: "#FAFAFA" }}
              rows="5"
              id="Service_description"
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Service Description"
            ></textarea>

            <div className="d-flex mb-4 align-items-center">
              <div>
                {Variant?.map((variant, key) => {
                  return (
                    <>
                      {key !== 0 ? <br /> : null}
                      <b>{variant.variantType} : </b>
                      {variant.values?.map((val) => {
                        return (
                          <Chip
                            label={val}
                            className="me-2 mb-2"
                            variant="outlined"
                            onDelete={() =>
                              handleDelete(variant.variantType, val)
                            }
                          />
                        );
                      })}
                    </>
                  );
                })}
              </div>
            </div>

            <div className="d-flex align-items-center">
              <FormControl fullWidth className="mb-4" size="small">
                <InputLabel id="demo-simple-select-label">
                  Select Variant Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={selectedVariant}
                  id="Service_Variant"
                  label="Status"
                  style={{ padding: "8px" }}
                  onChange={(e) => setselectedVariant(e.target.value)}
                >
                  {VariantTypes?.map((v) => {
                    return <MenuItem value={v.name}>{v.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <TextField
                className="mb-4"
                fullWidth
                sx={{ backgroundColor: "#FAFAFA" }}
                id="Service_variant"
                label="Add Variant Values"
                variant="outlined"
                value={newVariant}
                onKeyDown={(e) => {
                  console.log("Key Pressed");
                  if (e.keyCode == 13) {
                    console.log("Enter Pressed");
                    AddNewVariant();
                  }
                }}
                onChange={(e) => setnewVariant(e.target.value)}
              />
              <Button
                variant="contained"
                color="primary"
                className="mb-4"
                onClick={() => AddNewVariant()}
                style={{
                  backgroundColor: "#212C62",
                  marginLeft: "20px",
                  padding: "17px 50px",
                }}
                size="small"
                // startIcon={<CheckCircleIcon />}
              >
                Add
              </Button>
            </div>
            <div className="d-flex">
              <div className="d-flex justify-content-center flex-column">
                <h3>Select Colors</h3>
                <SketchPicker
                  color={SelectedColor}
                  className="col-12"
                  onChange={(e) => setSelectedColor(e.hex)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  className="mb-4"
                  onClick={(e) => {
                    setColors((Colors) => [
                      ...Colors,
                      SelectedColor.replace("#", ""),
                    ]);
                  }}
                  style={{
                    backgroundColor: "#212C62",
                    padding: "17px 50px",
                  }}
                  size="small"
                  // startIcon={<CheckCircleIcon />}
                >
                  Add Selected Collor
                </Button>
              </div>

              <div className="col-6">
                <h3>Current Colors</h3>
                {Colors?.length === 0 ? (
                  <small className="text-muted">No Color Selected</small>
                ) : null}
                {Colors?.map((Color, key) => {
                  return (
                    <Chip
                      key={key}
                      label={"#" + Color}
                      className="me-2 mb-2"
                      Variant="outlined"
                      style={{ backgroundColor: "#" + Color, color: "white" }}
                      onDelete={() => handleDeleteColor(Color)}
                    />
                  );
                })}
              </div>
            </div>
            {thumbnail && (
              <div className="border col-md-4 mb-4">
                <div className="d-flex w-100 justify-content-between px-2 pt-2">
                  <span>
                    <h5>Thumbnail</h5>
                  </span>
                  <span>
                    <DeleteForeverIcon
                      role="button"
                      onClick={() => setThumbnail("")}
                      className="text-danger"
                    />
                  </span>
                </div>
                <img src={thumbnail} width="100%" />
              </div>
            )}
            {downloadURLs && (
              <div className="d-flex row border-top justify-content-around ">
                <h5 className="my-3">Other Images</h5>
                {downloadURLs?.map((downloadURL, i) => {
                  return (
                    <>
                      <div className="border col-md-4">
                        <span>
                          <DeleteForeverIcon
                            role="button"
                            onClick={() => {
                              const newItems = downloadURLs.filter(
                                (item) => item !== downloadURL
                              );
                              setdownloadURLs(newItems);
                            }}
                            className="text-danger mb-4 mx-2 mt-2"
                          />
                        </span>
                        <img key={i} src={downloadURL} width="100%" />
                      </div>
                    </>
                  );
                })}
              </div>
            )}
            <div
              className="border my-4 rounded-1 d-flex align-items-center justify-content-between"
              style={{ padding: "16.5px", backgroundColor: "#FAFAFA" }}
            >
              <span></span>
              <label className="text-muted">
                Upload Thumbnail <FileUploadIcon />
                <FileUploader
                  accept="image/*"
                  name="image-uploader-multiple"
                  randomizeFilename
                  storageRef={app.storage().ref("Service_images")}
                  onUploadStart={handleUploadStart}
                  onUploadError={handleUploadError}
                  onUploadSuccess={handleUploadSuccessThumbnail}
                  onProgress={handleProgress}
                  multiple
                  id="uploadThumbnail"
                  role="button"
                  // onChange={customOnChangeHandler} // ⇐ Call your handler
                  // ref={fileUploader} // ⇐ reference the component
                />
              </label>
              <CameraAltIcon style={{ color: "#212C62" }} />
              {/* <input
                  type="file"
                  onChange={(e) => setUploadImage(e.target.files[0])}
                  id="uploadThumbnail"
                  hidden
                  accept="image/*"
                /> */}
            </div>

            <label
              className="mb-4 w-100 text-center"
              style={{
                backgroundColor: "#212C62",
                color: "white",
                padding: 10,
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Upload Service Images <FileUploadIcon />
              <FileUploader
                accept="image/*"
                name="image-uploader-multiple"
                randomizeFilename
                storageRef={app.storage().ref("Service_images")}
                onUploadStart={handleUploadStart}
                onUploadError={handleUploadError}
                onUploadSuccess={handleUploadSuccess}
                onProgress={handleProgress}
                multiple
                id="uploadImages"
                role="button"
                // onChange={customOnChangeHandler} // ⇐ Call your handler
                // ref={fileUploader} // ⇐ reference the component
              />
            </label>
            {UploadProgress > 1 ? (
              <ProgressBar lable={"Uploading Image"} value={UploadProgress} />
            ) : (
              <></>
            )}
            <div className="d-flex justify-content-center">
              <Button
                variant="contained"
                color="primary"
                className="mb-4"
                style={{
                  backgroundColor: "#212C62",
                  padding: "17px 50px",
                }}
                size="small"
                disabled={isProcessing}
                // startIcon={<CheckCircleIcon />}
                onClick={() => addService()}
                // onClick={startUploadManually}
              >
                {isProcessing ? (
                  <CircularProgress sx={{ color: "white" }} size={27} />
                ) : (
                  <>{DocId ? "Save Service" : "ADD NEW Service"}</>
                )}
              </Button>
            </div>
          </Box>
        </div>
      </Card>
    </div>
  );
}
